import React from 'react';
import styled from 'styled-components';

import { FilteredPointCloudCard } from './add-ons/filtered-point-cloud-card';
import { GcpAdjustmentCard } from './add-ons/gcp-adjustment-card';
import { TerrainModelCard } from './add-ons/terrain-model-card';

export interface AddOnData {
  terrainModel?: {
    enabled?: boolean;
  };
  gcpAdjustment?: {
    enabled?: boolean;
    comment?: string;
    selfReview?: boolean;
  };
  filteredPointCloud?: {
    enabled?: boolean;
    spacing?: number;
    classes?: FilteredPointCloudClassesOptions;
    format?: FilteredPointCloudFormatOptions;
  };
}

export type FilteredPointCloudClassesOptions = 'ALL' | 'GROUND';
export type FilteredPointCloudFormatOptions = 'DXF' | 'LAZ' | 'LAS';

type Props = {
  onChange: (data: AddOnData) => void;
  gcpPoints?: boolean;

  terrainModel: boolean;

  gcpAdjustment?: boolean;
  gcpAdjustmentComment?: string;
  gcpAdjustmentSelfReview?: boolean;
  useInteractiveSetup?: boolean;

  filteredPointCloud: boolean;
  filteredPointCloudSpacing?: number;
  filteredPointCloudFormat?: FilteredPointCloudFormatOptions;
  filteredPointCloudClasses?: FilteredPointCloudClassesOptions;
};

const AddOns = (props: Props) => {
  return (
    <Component>
      {props.gcpAdjustment !== undefined && (
        <GcpAdjustmentCard
          comment={props.gcpAdjustmentComment}
          gcpPoints={props.gcpPoints ?? false}
          selected={props.gcpAdjustment}
          selfReview={props.gcpAdjustmentSelfReview}
          onChange={props.onChange}
        />
      )}
      <TerrainModelCard selected={props.terrainModel} onChange={props.onChange} />
      <FilteredPointCloudCard
        classes={props.filteredPointCloudClasses}
        format={props.filteredPointCloudFormat}
        selected={props.filteredPointCloud}
        spacing={props.filteredPointCloudSpacing}
        onChange={props.onChange}
      />
    </Component>
  );
};

const Component = styled.div``;

export { AddOns };
